import { render, staticRenderFns } from "./icon3.vue?vue&type=template&id=6f8675d6&scoped=true&"
import script from "./icon3.vue?vue&type=script&lang=js&"
export * from "./icon3.vue?vue&type=script&lang=js&"
import style0 from "./icon3.vue?vue&type=style&index=0&id=6f8675d6&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8675d6",
  null
  
)

export default component.exports